import { render } from "./Carro.vue?vue&type=template&id=0f5c3270"
import script from "./Carro.vue?vue&type=script&lang=js"
export * from "./Carro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__